import { cn } from "@faire/prototype-playground/lib/utils";
import { Check } from "@phosphor-icons/react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-[4px] border border-[#d1d5db] shadow-sm transition-shadow outline-none focus-visible:border-[hsl(var(--ui-ring))] focus-visible:ring-2 focus-visible:ring-[hsl(var(--ui-ring))]/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-[#111827] data-[state=checked]:bg-[#111827] data-[state=checked]:text-(--slate-color-action-text-inverse)",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check size={12} weight="bold" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
